import type { FC } from 'react';
import { AlertCircle, CheckCircle, InfoCircle } from '@untitledui/icons';
import type { AlertColor, AlertColorVariant } from './alerts.types';

export const alertColorVariants: Record<AlertColor, AlertColorVariant> = {
  gray: {
    floating: 'bg-primary border-primary',
    fullWidth: 'bg-primary border-b-primary',
    icon: 'text-fg-tertiary',
    iconRing: 'border-fg-tertiary',
    title: 'text-secondary',
    description: 'text-tertiary',
    closeButton: 'text-quaternary hover:text-tertiary',
    dismissButton: 'text-tertiary hover:text-secondary',
    actionButton: 'text-brand-secondary hover:text-brand-primary'
  },
  brand: {
    floating: 'bg-utility-brand-50 border-utility-brand-100',
    fullWidth: 'bg-primary border-b-primary',
    icon: 'text-fg-brand-primary',
    iconRing: 'border-fg-brand-primary',
    title: 'text-secondary',
    description: 'text-tertiary',
    closeButton: 'text-quaternary hover:text-tertiary',
    dismissButton: 'text-tertiary hover:text-secondary',
    actionButton: 'text-brand-secondary hover:text-brand-primary'
  },
  error: {
    floating: 'bg-utility-error-50 border-utility-error-100',
    fullWidth: 'bg-utility-error-50 border-b-utility-error-100',
    icon: 'text-fg-error-primary',
    iconRing: 'border-fg-error-primary',
    title: 'text-utility-error-600',
    description: 'text-utility-error-600',
    closeButton: 'text-utility-error-700 hover:text-utility-error-800',
    dismissButton: 'text-error-primary hover:text-utility-error-700',
    actionButton: 'text-brand-secondary hover:text-utility-error-800'
  },
  warning: {
    floating: 'bg-utility-warning-50 border-utility-warning-100',
    fullWidth: 'bg-utility-warning-50 border-b-utility-warning-100',
    icon: 'text-fg-warning-primary',
    iconRing: 'border-fg-warning-primary',
    title: 'text-utility-warning-700',
    description: 'text-utility-warning-600',
    closeButton: 'text-utility-warning-700 hover:text-utility-warning-800',
    dismissButton: 'text-utility-warning-600 hover:text-utility-warning-700',
    actionButton: 'text-utility-warning-600 hover:text-utility-warning-700'
  },
  success: {
    floating: 'bg-utility-success-50 border-utility-success-100',
    fullWidth: 'bg-utility-success-50 border-b-utility-success-100',
    icon: 'text-fg-success-primary',
    iconRing: 'border-fg-success-primary',
    title: 'text-utility-success-700',
    description: 'text-utility-success-600',
    closeButton: 'text-utility-success-700 hover:text-utility-success-800',
    dismissButton: 'text-utility-success-600 hover:text-utility-success-700',
    actionButton: 'text-utility-success-600 hover:text-utility-success-700'
  }
};

export const defaultIcons: Record<AlertColor, FC<{ className?: string }>> = {
  gray: InfoCircle,
  brand: InfoCircle,
  error: AlertCircle,
  warning: AlertCircle,
  success: CheckCircle
};
